
export default {
    vi: {
        header: 'Đăng ký bằng Google',
        description: 'Dùng tài khoản Google của bạn để đăng ký tài khoản mới',
        register: 'Quay lại đăng ký',
        login: 'Đăng nhập',
        username: 'Tên tài khoản',
        password: 'Mật khẩu',
        repassword: 'Nhập lại mật khẩu',
        invalidUsername: 'Tên tài khoản không hợp lệ',
        invalidPassword: 'Mật khẩu phải có tối thiểu 8 ký tự bao gồm số, chữ hoa, chữ thường và ký tự đặc biệt',
        invalidRepassword: 'Hai mật khẩu không trùng nhau',
        errorMessage: 'Đã có lỗi xảy ra, vui lòng thử lại sau'
    }, 
    en: {
        header: 'Register with Google',
        description: 'Register with your Google account',
        register: 'Back to register',
        login: 'Login',
        username: 'Username',
        password: 'Password',
        repassword: 'Re-enter password',
        invalidUsername: 'Username is invalid',
        invalidPassword: 'Password must have at least 8 characters including number, uppercase, lowercase and special character',
        invalidRepassword: 'The two passwords do not match',
        errorMessage: 'There was an error, please try again later'
    }
}
